import React, { Component } from "react";
import CssClasses from "./DataTable.css";

class DataTable extends Component {
  componentDidMount() {
    console.log(this.props.headers);
    console.log(this.props.data);
  }

  render() {
    let rowCounter = 0;

    return (
      <div className={CssClasses.container}>
        <table className={CssClasses.tblMain}>
          <thead>
            <tr className={CssClasses.headerRow}>
              {this.props.headers.map(headerInfo => {
                return (
                  <th
                    key={headerInfo.id}
                    className={[
                      CssClasses.headerCell,
                      headerInfo.alignment === "L"
                        ? CssClasses.leftAligned
                        : CssClasses.rightAligned,
                      this.getColumWidth(headerInfo.width)
                    ].join(" ")}
                  >
                    {headerInfo.caption}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody
            style={{
              overflow: "auto",
              maxHeight: this.props.config.maxDataHeight + "px"
            }}
          >
            {this.props.data
              ? this.props.data.map(obj => {
                  rowCounter++;

                  if (!obj.id) {
                    obj.id = rowCounter;
                  }

                  return (
                    <tr
                      key={obj.id}
                      className={[
                        CssClasses.dataRow,
                        rowCounter % 2 === 0 ? CssClasses.alternateRow : ""
                      ].join(" ")}
                    >
                      {this.props.headers.map(headerInfo => {
                        return (
                          <td
                            key={headerInfo.id}
                            className={[
                              CssClasses.dataCell,
                              headerInfo.alignment === "L"
                                ? CssClasses.leftAligned
                                : CssClasses.rightAligned,
                              this.getColumWidth(headerInfo.width)
                            ].join(" ")}
                          >
                            {headerInfo.dataType === "bool"
                              ? obj[headerInfo.dataField] === true
                                ? "DA"
                                : "NE"
                              : headerInfo.dataType === "numeric"
                              ? obj[headerInfo.dataField].toFixed(2)
                              : obj[headerInfo.dataField]}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })
              : null}
          </tbody>
        </table>
      </div>
    );
  }

  getColumWidth(width) {
    switch (width) {
      case 10:
        return CssClasses.colWidth10;
      case 15:
        return CssClasses.colWidth15;
      case 20:
        return CssClasses.colWidth20;
      case 25:
        return CssClasses.colWidth25;
      case 30:
        return CssClasses.colWidth30;
      case 35:
        return CssClasses.colWidth35;
      case 40:
        return CssClasses.colWidth40;
      default:
        return "";
    }
  }
}

export default DataTable;



// WEBPACK FOOTER //
// ./src/Components/DataTable/DataTable.js